import Vue from "vue";
import Vuex from "vuex";
// modulos;
import app from "./app";
import lectio from "./lectio";
import pasos from "./pasos";
import user from "./user";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    lectio,
    pasos,
    user
  }
});

export default store;
